const GrowthCenter = () =>
  import(
    /* webpackChunkName: "growthCenter~index" */ 'page/platform/growthCenter/index.vue'
  )

const GrowthLogs = () =>
  import(
    /* webpackChunkName: "growthCenter~logs" */ 'page/platform/growthCenter/logs.vue'
  )

const LevelExplain = () =>
  import(
    /* webpackChunkName: "growthCenter~levelExplain" */ 'page/platform/growthCenter/levelExplain.vue'
  )

const EquityDetail = () =>
  import(
    /* webpackChunkName: "growthCenter~equityDetail" */ 'page/platform/growthCenter/equityDetail.vue'
  )

const MyEquity = () =>
  import(
    /* webpackChunkName: "growthCenter~myEquity" */ 'page/platform/growthCenter/myEquity.vue'
  )

let routes = [
  {
    path: '/growthCenter',
    component: GrowthCenter,
    meta: {
      cache: false,
      pageName: '用户成长中心',
      business: '平台',
      title: '用户成长中心'
    }
  },
  {
    path: '/growthCenter/logs',
    component: GrowthLogs,
    meta: {
      cache: false,
      pageName: '成长日志',
      business: '平台',
      title: '成长日志'
    }
  },
  {
    path: '/growthCenter/levelExplain',
    component: LevelExplain,
    meta: {
      cache: false,
      pageName: '壹心理浪花值说明',
      business: '平台',
      title: '壹心理浪花值说明'
    }
  },
  {
    path: '/growthCenter/equityDetail/:id',
    component: EquityDetail,
    meta: {
      cache: false,
      pageName: '权益详情',
      business: '平台',
      title: '权益详情'
    }
  },
  {
    path: '/growthCenter/myEquity',
    component: MyEquity,
    meta: {
      cache: false,
      pageName: '我的权益',
      business: '平台',
      title: '我的权益'
    }
  }
]

export default routes
